module.exports = __webpack_public_path__ + "img/hong-kong.742459f0.png";